import React from 'react';
import HelperGenie from '../components/HelperGenie';

/**
 * Public-facing apex page.
 *
 * Replaces the previous behaviour where `/` redirected to `/admin/overview`,
 * which forced every visitor through the admin login form and effectively
 * advertised the admin URL. This page is intentionally minimal — admin
 * users navigate directly to `/adminlogin` (unlinked).
 */
export default function PublicLanding() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md text-center px-6">
                <h1 className="text-4xl font-bold text-zebcast-purple mb-3">ZebCast</h1>
                <p className="text-gray-600 mb-6">
                    Cast videos, photos and music from your phone to TVs, streaming
                    sticks and dongles — DLNA, Chromecast, Miracast, Roku.
                </p>
                <div className="space-x-4 text-sm">
                    <a href="https://play.google.com/store/apps/details?id=com.ezbm.cast.zebcast"
                       className="text-zebcast-purple hover:underline">
                        Get the app
                    </a>
                    <span className="text-gray-300">·</span>
                    <a href="/privacy" className="text-gray-600 hover:underline">Privacy</a>
                    <span className="text-gray-300">·</span>
                    <a href="/support" className="text-gray-600 hover:underline">Support</a>
                </div>
            </div>
            <HelperGenie />
        </div>
    );
}
